<template>
    <div class="profile-tabs__wrapper profile-tabs__wrapper--volunteer">

        <div class="profile-tabs">
            <div class="profile-tabs__header-text">{{$store.getters.t('user_dashboard_tabs_donations')}}</div>

            <template v-if="array.length && loaded">
                <div class="profile-tabs__scroll-wrapper">
                    <div class="profile-tabs__body profile-tabs__body--philanthropists">

                        <div class="profile-tabs__body-item d-flex" v-for="({pet = null, project = null, user, ...item}, index) in array" :key="index">

                            <template v-if="pet && item">
                                <div class="profile-tabs__body-header">
                                    <a :href="`/user/${user.id}/profile`" class="profile-tabs__body-image">
                                        <img :src="`/storage/${user.avatar.path.replace('original', 'avatar')}`" :alt="user.name" v-if="user.avatar">
                                        <span v-else v-text="getUserPM(user.name || 'Anonymous')"></span>
                                    </a>
                                </div>

                                <div class="profile-tabs__body-content">
                                    <a :href="`/user/${user.id}/profile`" class="profile-tabs__body-name">{{ user.name }}</a>
                                    <div class="profile-tabs__body-info">{{item.credit}} USD</div>
                                    <a :href="`/pets/${item.pet_id}`" class="profile-tabs__body-meta">{{pet.name}}</a>
                                </div>
                            </template>

                            <template v-if="project && item">
                                <div class="profile-tabs__body-header">
                                    <a :href="`/user/${user.id}/profile`" class="profile-tabs__body-image">
                                        <img :src="`/storage/${user.avatar.path.replace('original', 'avatar')}`" :alt="user.name" v-if="user.avatar">
                                        <span v-else v-text="getUserPM(user.name || 'Anonymous')"></span>
                                    </a>
                                </div>

                                <div class="profile-tabs__body-content">
                                    <a :href="`/user/${user.id}/profile`" class="profile-tabs__body-name">{{ user.name }}</a>
                                    <div class="profile-tabs__body-info">{{item.credit}} USD</div>
                                    <a :href="`/projects/${item.project_id}`" class="profile-tabs__body-meta">{{project.name}}</a>
                                </div>
                            </template>


                        </div>

                    </div>
                </div>
            </template>
            <template v-else-if="!loaded">
                <div class="profile-dashboard__pets-slider profile-dashboard__pets-slider--empty d-flex">
                    <div class="LoaderBalls">
                        <div class="LoaderBalls__item"></div>
                        <div class="LoaderBalls__item"></div>
                        <div class="LoaderBalls__item"></div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="profile-tabs__body profile-tabs__body--empty d-flex">

                    {{$store.getters.t('facilities_list_empty')}}

                </div>
            </template>


        </div>

    </div>
</template>

<script>

import Tabs from '../tabs/Tabs';
import Tab from '../tabs/Tab';

export default {
    name: "UserDashboardTabs",
    props: ['user'],
    components: {Tab, Tabs},
    data() {
        return {
            array: [],
            loaded: false,
        }
    },


    async mounted() {
        await this.getDonated()
    },

    methods: {

        async getDonated() {

            const params = {
                per_page: 20,
                page: 1,
            }

            try {
                const {data} = await axios.get( `/api/user/donations-transactions`, { params: params } )
                this.array = data.data.sort( ( _a, _b ) => ( _b.credit - _a.credit ) )

            } catch (e) {
                console.log(e)
            }
        },

        getUserPM(name) {
            let nameArray = name.trim().split(' ');
            return nameArray[0][0] + ((nameArray[1]) ? nameArray[1][0] : '') + '';
        },
    },

    watch: {
        array() {
            setTimeout(() => {
                this.loaded = true
            }, 1000)
        }
    },


}
</script>

<style scoped>

</style>
